import segment from 'src/js/modules/analytics/segment';

const trackUpgradeInApp = (trackingData) =>
  segment.track(segment.constants.events.UPGRADE_INITIATED, {
    ...trackingData,
    productCategory: segment.constants.common.EDITOR_PRODUCT_CATEGORY,
  });

export default trackUpgradeInApp;
